module.exports = ".footer {\n    text-align: center;\n    background-color: white;\n    border-top: 1px solid #033E5E;\n    height: 84px;\n}\n\n.footer img {\n    height: 80px;\n    margin: 0px 12px;\n    float: none;\n    display: inline-block\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.css
// module id = ./src/app/components/footer/footer.component.css
// module chunks = main